import { Injectable } from '@angular/core';
import { LoadingController } from "@ionic/angular";

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  constructor(public loadingController: LoadingController) { }

  showHideAutoLoader(message: string = '', duration: number = 2000) {

    this.loadingController.create({
      message: message,
      duration: duration,
      backdropDismiss:true,
      spinner: "circular",
      cssClass: 'desade-ion-loader'
    }).then((res) => {
      res.present();

      res.onDidDismiss().then((dis) => {
        console.log('Loading dismissed! after 2 Seconds', dis);
      });
    });

  }

  /**
   * spinner: bubbles | circles | crescent
   * @param message
   */
  async showLoader(message: string = '') {
    const loading = await this.loadingController.create({
      backdropDismiss: true,
      spinner: "circular",
      message: message,
      cssClass: 'desade-ion-loader',
    });
    await loading.present();
  }

  // Hide the loader if already created otherwise return error
  hideLoader() {
    this.loadingController.dismiss().then((res) => {
    }).catch((error) => {
    });
  }
}
